import { SvgProps } from '../SvgRendererTypes';

export const NeighborsPSSIcon = ({ fillColor, ...props }: SvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Neighbors PSS Icon</title>
      <g id="PMP_Neighbors_1024" transform="translate(-47.000000, -134.000000)">
        <g id="_x30_1_x5F_Hero" transform="translate(-50.000000, 58.000000)">
          <g id="Contents-" transform="translate(94.000000, 75.000000)">
            <g id="_x31_024-logo" transform="translate(3.000000, 0.000000)">
              <g id="Group-3" transform="translate(0.000000, 0.883524)">
                <defs>
                  <filter
                    id="Adobe_OpacityMaskFilter"
                    filterUnits="userSpaceOnUse"
                    x="0"
                    y="0.1"
                    width="38"
                    height="38"
                  >
                    <feColorMatrix
                      type="matrix"
                      values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                    />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0.1"
                  width="38"
                  height="38"
                  id="mask-2_1_"
                >
                  <g>
                    <polygon id="path-1_1_" points="0,0.1 38,0.1 38,38.1 0,38.1 							" />
                  </g>
                </mask>
                <path
                  id="Fill-1"
                  fill={fillColor}
                  d="M19,36.2c-9.4,0-17.1-7.7-17.1-17.1C1.9,9.6,9.6,2,19,2c9.4,0,17.1,7.7,17.1,17.1
							C36.1,28.5,28.5,36.2,19,36.2 M19,0.1c-10.5,0-19,8.5-19,19c0,10.5,8.5,19,19,19c10.5,0,19-8.5,19-19C38,8.6,29.5,0.1,19,0.1"
                />
              </g>
              <path
                id="Fill-4"
                fill={fillColor}
                d="M26.8,21.3c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9
						C29.7,20,28.4,21.3,26.8,21.3 M19,19c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3
						C22.3,17.5,20.8,19,19,19 M11.6,21.3c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9
						C14.5,20,13.2,21.3,11.6,21.3 M19,5.2C10.9,5.2,4.3,11.8,4.3,20c0,4,1.6,7.7,4.3,10.4c-0.4-1.1-0.8-2.5-0.8-3.7
						c0-2.3,3-3,4.6-3.4c-0.4,3,0.2,5.9,1.3,8.5c0.1,0.1,0.3,0.1,0.2-0.1c-0.4-2.7-0.5-5.8-0.2-8c0.4-2.8,3.5-2.7,5.2-2.7
						c1.7,0,4.9-0.1,5.3,2.7c0.3,2.3,0.2,5.3-0.2,8c0,0.1,0.2,0.2,0.2,0.1c1.2-2.6,1.7-5.5,1.3-8.5c1.6,0.3,4.6,1.1,4.6,3.4
						c0,0.2,0,0.3,0,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.2
						c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.1-0.1,0.2
						c0,0.1-0.1,0.3-0.1,0.4c0,0,0,0,0,0.1c-0.1,0.1-0.1,0.3-0.2,0.4v0c2.6-2.7,4.3-6.3,4.3-10.4C33.7,11.8,27.2,5.2,19,5.2"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
